import React from 'react'

import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import { themeProvider } from 'decorators'
import { createRoot } from 'react-dom/client'

import { isDiscardedBugsnagEvent } from '@albacross/frontend-utils'

import ErrorFallback from 'components/ErrorFallback'
import Root from 'components/Root'
import configureStore from 'utils/store'

import config from '../config'
import pkg from '../package.json'
import rootReducer from './reducers'
import routes from './routes'

import './main.scss'

const MOUNT_ELEMENT = document.getElementById('root')

const store = configureStore(rootReducer)

const RootComponent = themeProvider(Root)

Bugsnag.start({
  apiKey: config.bugsnag_api_key,
  appVersion: pkg.version,
  releaseStage: process.env.NODE_ENV,
  redactedKeys: ['password', 'access_token'],
  plugins: [new BugsnagPluginReact(React)],
  onError: event => !isDiscardedBugsnagEvent(event),
})

window.Bugsnag = Bugsnag

// Render the React application to the DOM
const render = () => {
  // eslint-disable-next-line no-console
  console.info(`Application ${pkg.name} started (version: ${pkg.version})`)

  const ErrorBoundary = Bugsnag.getPlugin('react')!.createErrorBoundary()

  createRoot(MOUNT_ELEMENT!).render(
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <RootComponent routes={routes} store={store} />
    </ErrorBoundary>,
  )
}

render()
